import styled from '@emotion/styled';
import { Button, Link, Text } from '~/shared/components';
import { ResetButton } from '~/shared/components/Button/ResetButton';
import { breakpoints } from '~/theme/breakpoints';
import { ifProp } from 'styled-tools';
import { LoginButton } from '~/features/navigation/components/N20MainMenu/components/LoginButton';

type StyledIconButtonProps = {
    active?: boolean;
    mobileOnly?: boolean;
    small?: boolean;
    full?: boolean;
    desktop?: boolean;
    textColor?: string;
};

export const StyledIconButtonCloseCheckoutBanner = styled(ResetButton)<{ textColor: string }>(
    ({ textColor, theme }) => ({
        padding: 0,
        position: 'relative',
        marginRight: theme.space[3],
        svg: {
            width: 16,
            height: 16,
            '& path': {
                fill: textColor,
            },
        },
        [breakpoints.md]: {
            display: 'none',
        },
    }),
);
export const StyledCheckoutBannerTextLink = styled(Link)<{
    textColor: string;
    withCloseBanner?: boolean;
    showTopBanner?: boolean;
    desktop?: boolean;
    withDecoration?: boolean;
    justifyContent?: string;
}>(
    ({ theme, textColor }) => ({
        ...theme.mixins.useTextStyle('bodySmall'),
        color: textColor ? textColor : theme.colors.white,
        textAlign: 'center',
        textJustify: 'auto',
        display: 'flex',
        flexGrow: 1,
        flexBasis: 0,
        margin: '0 auto',
        letterSpacing: 0,
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: theme.lineHeights['base'],
        padding: `0 ${theme.space[1]} 0 0`,
        [breakpoints.xs]: {
            lineHeight: theme.lineHeights['base'],
        },
    }),
    ifProp('desktop', ({ theme }) => ({
        padding: 'unset',
        marginTop: 'unset',
        lineHeight: `${theme.space[5]}`,
    })),
    ifProp('withDecoration', () => ({
        textDecoration: 'underline',
    })),
    ifProp('justifyContent', ({ justifyContent }) => ({
        justifyContent: justifyContent,
    })),
);
export const StyledCheckoutBannerTextLinkDesktop = styled(Link)<{
    textColor: string;
    withCloseBanner?: boolean;
    showTopBanner?: boolean;
    desktop?: boolean;
    withDecoration?: boolean;
    justifyContent?: string;
}>(
    ({ theme, textColor }) => ({
        color: textColor ? textColor : theme.colors.white,
        fontSize: theme.fontSizes['xs'],
        textAlign: 'center',
        textJustify: 'auto',
        display: 'flex',
        letterSpacing: 0,
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: theme.lineHeights['base'],
        padding: `0 ${theme.space[1]} 0 0`,
        [breakpoints.xs]: {
            lineHeight: theme.lineHeights['base'],
        },
    }),
    ifProp('desktop', ({ theme }) => ({
        padding: 'unset',
        marginTop: 'unset',
        lineHeight: `${theme.space[5]}`,
    })),
    ifProp('withDecoration', () => ({
        textDecoration: 'underline',
    })),
    ifProp('justifyContent', ({ justifyContent }) => ({
        justifyContent: justifyContent,
    })),
);
export const StyledCheckoutBannerText = styled(Text)<{
    textColor: string;
    withCloseBanner?: boolean;
    showTopBanner?: boolean;
    desktop?: boolean;
    bannerTextAlignStart?: boolean;
    flexGrow?: boolean;
}>(
    ({ theme, textColor }) => ({
        color: textColor ? textColor : theme.colors.white,
        fontSize: theme.fontSizes['xs'],
        flexGrow: 1,
        margin: '0 auto',
        flexBasis: 0,
        justifyContent: 'center',
        textAlign: 'center',
        textJustify: 'auto',
        display: 'flex',
        letterSpacing: 0,
        alignItems: 'center',
        lineHeight: theme.lineHeights['base'],
        padding: 0,
        [breakpoints.xs]: {
            lineHeight: theme.lineHeights['base'],
            fontSize: theme.fontSizes['xs'],
        },
    }),
    ifProp('desktop', ({ theme }) => ({
        padding: 'unset',
        marginTop: 'unset',
        lineHeight: `${theme.space[5]}`,
    })),
    ifProp('bannerTextAlignStart', () => ({
        flexGrow: 'unset',
        margin: 'unset',
        flexBasis: 'unset',
        justifyContent: 'flex-start',
    })),
    ifProp('flexGrow', () => ({
        flexGrow: 4,
    })),
);
export const StyledCheckoutgoForwardText = styled(Text)<{
    textColor: string;
    withCloseBanner?: boolean;
    showTopBanner?: boolean;
    desktop?: boolean;
    bannerTextAlignCenter?: boolean;
}>(
    ({ theme, textColor }) => ({
        color: textColor ? textColor : theme.colors.white,
        fontSize: theme.fontSizes['xs'],
        flexGrow: 1,
        margin: '0 auto',
        flexBasis: 0,
        justifyContent: 'flex-end',
        textAlign: 'center',
        textJustify: 'auto',
        display: 'flex',
        letterSpacing: 0,
        alignItems: 'center',
        lineHeight: theme.lineHeights['base'],
        padding: theme.space[1],
        [breakpoints.xs]: {
            lineHeight: theme.lineHeights['base'],
            fontSize: theme.fontSizes['xs'],
        },
        button: {
            flexDirection: 'row',
        },
    }),
    ifProp('desktop', ({ theme }) => ({
        padding: 'unset',
        marginTop: 'unset',
        lineHeight: `${theme.space[5]}`,
    })),
    ifProp('bannerTextAlignCenter', () => ({
        justifyContent: 'flex-start',
    })),
);
export const StyledCheckoutBannerTextDesktop = styled(Text)<{
    textColor: string;
    withCloseBanner?: boolean;
    showTopBanner?: boolean;
    desktop?: boolean;
}>(
    ({ theme, textColor }) => ({
        color: textColor ? textColor : theme.colors.white,
        fontSize: theme.fontSizes['xs'],
        flexGrow: 1,
        margin: '0 auto',
        flexBasis: 0,
        justifyContent: 'flex-start',
        textAlign: 'center',
        textJustify: 'auto',
        display: 'flex',
        letterSpacing: 0,
        alignItems: 'center',
        lineHeight: theme.lineHeights['base'],
        padding: 0,
        [breakpoints.xs]: {
            lineHeight: theme.lineHeights['base'],
            fontSize: theme.fontSizes['xs'],
        },
    }),
    ifProp('desktop', ({ theme }) => ({
        padding: 'unset',
        marginTop: 'unset',
        lineHeight: `${theme.space[5]}`,
    })),
);
export const StyledCheckoutgoForwardTextDesktop = styled(Text)<{
    textColor: string;
    withCloseBanner?: boolean;
    showTopBanner?: boolean;
    desktop?: boolean;
}>(
    ({ theme, textColor }) => ({
        color: textColor ? textColor : theme.colors.white,
        fontSize: theme.fontSizes['xs'],
        flexGrow: 1,
        margin: '0 auto',
        flexBasis: 0,
        justifyContent: 'flex-end',
        textAlign: 'center',
        textJustify: 'auto',
        display: 'flex',
        letterSpacing: 0,
        alignItems: 'center',
        lineHeight: theme.lineHeights['base'],
        padding: 0,
        [breakpoints.xs]: {
            lineHeight: theme.lineHeights['base'],
            fontSize: theme.fontSizes['xs'],
        },
    }),
    ifProp('desktop', ({ theme }) => ({
        padding: 'unset',
        marginTop: 'unset',
        lineHeight: `${theme.space[5]}`,
    })),
);

export const StyledIconButtonCheckoutBannerButton = styled(Button)<StyledIconButtonProps>(
    ({ theme }) => ({
        display: 'flex',
        padding: `0 0 0 ${theme.space[1]}}`,
        alignItems: 'center',
        justifyContent: 'flex-start',
        alignContent: 'center',
    }),
);
export const StyledIconButtonCheckoutBannerDesktop = styled(ResetButton)<StyledIconButtonProps>(
    ({ theme }) => ({
        display: 'flex',
        padding: `0 0 0 ${theme.space[1]}}`,
        alignItems: 'center',
        justifyContent: 'flex-start',
        alignContent: 'center',
        svg: {
            height: '16px',
            width: '16px',
            margin: `0 ${theme.space[2]} 0 ${theme.space[2]}`,
        },
    }),
);
export const StyledDiv = styled.div<StyledIconButtonProps>(({ theme }) => ({
    marginTop: theme.space[5],
    marginBottom: theme.space[3],
    width: '100%',
    display: 'flex',
    [breakpoints.xs]: {
        display: 'none',
    },
    [breakpoints.sm]: {
        display: 'none',
    },
    [breakpoints.md]: {
        display: 'flex',
    },
}));

export const StyledLoginButton = styled(LoginButton)(() => ({
    display: 'flex',
    flexDirection: 'row',
}));
